// CrashHistoryButton.tsx
import { MoonWinResult } from '@crownbit/icons';
import { Box } from '@mui/material';
import React, { useState } from 'react';
import CrashHistoryModal from './HistoryModal';
import { queryClient } from '@/reactQueryKeys/queryClient';

const CrashHistoryButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    // refresh crash history
    queryClient.invalidateQueries({ queryKey: ['crashHistory'] });
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Box
        style={{
          marginLeft: '16px',
        }}
        sx={(theme) => ({
          width: '32px',
          height: '32px',
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '8px',
          background: theme.palette.bg.secondary,
          border: theme.palette.border.normal,
          '&:hover': {
            cursor: 'pointer',
          },
        })}
      >
        <MoonWinResult onClick={handleClick} fontSize={'large'} />
      </Box>
      <CrashHistoryModal isOpen={isOpen} handleClose={handleClose} />
    </>
  );
};

export default CrashHistoryButton;
